import React, { useEffect, useMemo, useState } from 'react';
import { Segmented } from 'antd';
import { BulbOutlined, DesktopOutlined, StarFilled } from '@ant-design/icons';
import {
  THEME_MODES,
  applyThemeMode,
  getStoredThemeMode,
  setStoredThemeMode,
} from '../config/themeMode';
import { useAppTheme } from '../hooks/useAppTheme';
import './ThemeModeToggle.css';

const ICONS = {
  auto: <DesktopOutlined />,
  dark: <StarFilled />,
  light: <BulbOutlined />,
};

export default function ThemeModeToggle({ className = '' }) {
  const { mode } = useAppTheme();
  const [selectedMode, setSelectedMode] = useState(getStoredThemeMode);

  useEffect(() => {
    setSelectedMode(mode);
  }, [mode]);

  const options = useMemo(
    () =>
      THEME_MODES.map((m) => ({
        label: (
          <span className='theme-toggle__option'>
            <span className='theme-toggle__icon' aria-hidden>
              {ICONS[m.value]}
            </span>
            <span className='theme-toggle__label'>{m.label}</span>
          </span>
        ),
        value: m.value,
      })),
    [],
  );

  const onChange = (value) => {
    setSelectedMode(value);
    setStoredThemeMode(value);
    applyThemeMode(value);
  };

  return (
    <Segmented
      size='small'
      className={`theme-toggle ${className}`.trim()}
      options={options}
      value={selectedMode}
      onChange={onChange}
    />
  );
}

